import React, { Component } from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import NumberInput from "../../../../Common/numberInput";
import SuggestSelectInput from "../../../../Common/suggestSelectInput";
import Validator from "../../../../Common/validator";

class ListItem extends Component {
  constructor(props) {
    super(props);
    const { item } = this.props;
    this.state = {
      suggestionsValue: {
        name: item.name,
        id: item.id,
      },
    };
  }
  // shouldComponentUpdate = (nextProps) => {
  //   return (
  //     nextProps.item !== this.props.item ||
  //     nextProps.suggestions !== this.props.suggestions ||
  //     nextProps.recent !== this.props.recent
  //   );
  // };
  componentWillReceiveProps = (nextProps) => {
    if (nextProps.item.name !== this.state.suggestionsValue.name) {
      this.setState({
        suggestionsValue: {
          name: nextProps.item.name,
          id: nextProps.item.id,
        },
      });
    }
  };
  onSuggestionChange = (val) => {
    const { updateUsageKind } = this.props;
    updateUsageKind(
      val.id,
      val.name,
      val.unit,
      val.dataSheetUrl,
      val.technicalDataSheetUrl,
      val.chemDataSheetUrl
    );
    this.setState({
      suggestionsValue: val,
    });
  };
  render() {
    const {
      item,
      updateUsageAmount,
      getUsageSuggestions,
      suggestions,
      setUsageAmountTouched,
      setUsageKindTouched,
      addEmptyUsage,
      isKindValid,
      isAmountValid,
      addSub,
      recent = []
    } = this.props;
    const { suggestionsValue } = this.state;
    return (
      <div>
        <div className="row" style={styles.container}>
          <div style={styles.firstColumn} className="col-xs-8">
            <Validator isValid={isKindValid}>
              <SuggestSelectInput
                type={this.props.type}
                onQuery={getUsageSuggestions}
                suggestions={suggestions}
                recent={recent}
                placeholder="..."
                onChange={(val) => {
                  this.onSuggestionChange(val);
                  addEmptyUsage();
                }}
                value={suggestionsValue}
                inputStyle={styles.input}
                onBlur={setUsageKindTouched}
              />
            </Validator>
          </div>
          <div className="col-xs-2">
            <Validator isValid={isAmountValid}>
              <NumberInput
                style={styles.input}
                onChange={(val) => {
                  updateUsageAmount(val);
                  if (val) addEmptyUsage();
                }}
                onBlur={setUsageAmountTouched}
                value={item.amount}
                shouldNotCallOnChangeOnMount={true}
              />
            </Validator>
          </div>
          <div style={styles.unit} className="col-xs-1">
            {item.unit}
          </div>
          <div style={styles.ekstra} className="col-xs-1">
            <button onClick={() => {
              addSub()
            }} className="btn">+</button>
          </div>
        </div>
        {this.props.children}
      </div>
    );
  }
}

var styles = {
  container: {
    marginLeft: "0",
    marginRight: "0",
    marginBottom: "8px",
    lineHeight: "35px",
  },
  firstColumn: {
    paddingLeft: "0",
  },
  unit: {
    textAlign: "right",
  },
  ekstra: {
    textAlign: "center",
  },
  input: {
    "-webkit-appearance": "none",
    border: "none",
    display: "block",
  },
};
ListItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    unit: PropTypes.string,
    kindTouched: PropTypes.bool,
    amount: PropTypes.number.isRequired,
    amountTouched: PropTypes.bool,
  }),
  isKindValid: PropTypes.bool.isRequired,
  isAmountValid: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  type: PropTypes.oneOf(["materiel", "materiale"]),
  updateUsageAmount: PropTypes.func.isRequired,
  getUsageSuggestions: PropTypes.func.isRequired,
  suggestions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      unit: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  updateUsageKind: PropTypes.func.isRequired,
  setUsageAmountTouched: PropTypes.func.isRequired,
  setUsageKindTouched: PropTypes.func.isRequired,
  addEmptyUsage: PropTypes.func.isRequired,
};
export default Radium(ListItem);



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/DailyReport/Usage/listItem.jsx